export class EnvNotExistsError extends Error {
  constructor({name, place}: {
    name: string,
    place: string
  }) {
    super(`The environment variable '${name}' does not exist. Attempted to retrieve it from '${place}'.`);
  }
}